// extracted by mini-css-extract-plugin
export default {"comment_all":"CommentEditor_comment_all__EUCl9","coment_textarea":"CommentEditor_coment_textarea__QYO+B","item_project":"CommentEditor_item_project__fH7qy"};